var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#open-new-tab';
                    var viewUrl = 'svg/global.svg#view-open-new-tab';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };